export default __webpack_public_path__ + "static/media/md-card-bg-ba-finance.d8fcb2d5.png";